import React, {useState} from 'react'
import {Link} from 'react-router-dom'
import {t} from 'i18next'
import {observer} from 'mobx-react'
import {useInjection} from 'dna-react-ioc'
import {Button, Modal, Typography} from 'antd'

import {PageHeader} from '~/code/components'
import {useScreenType} from '~/code/hooks'
import {InfoCircleOutlined} from '@ant-design/icons'
import {withTitle} from '@/router/utils'
import {isDCCModalLinkShown} from '@/constants/dcc'

import {DccTableFilter} from './components/DccTableFilter'
import {DccTable} from './components/DccTable'
import {IDccStore} from './IDccStore'
import {learnMoreDccUrl} from './constants'
import styles from './styles.scss'

export const DccStoreSymbol = Symbol('DccStore')

const DCC = observer(() => {
    const {isMobile} = useScreenType()
    const store = useInjection<IDccStore>(DccStoreSymbol)
    const {reload, isLoading} = store
    const [isModalOpen, setModal] = useState(false)

    return (
        <>
            <PageHeader
                onBack={null}
                title={
                    <div className={styles.titleWrapper}>
                        <Typography.Title className={styles.title} level={4}>
                            {isMobile ? t('DCC.dcc') : t('DCC.title')}
                        </Typography.Title>
                        <Link
                            className={styles.iconWrapper}
                            to={'#'}
                            onClick={() => setModal(true)}
                        >
                            <InfoCircleOutlined className={styles.popupIcon} />
                        </Link>
                    </div>
                }
                border={'none'}
            >
                <DccTableFilter
                    openExportsModal={() => null}
                    onReloadClick={reload}
                    loading={isLoading}
                />
            </PageHeader>
            <DccTable />

            <Modal
                title={t('DCC.modalTitle')}
                open={isModalOpen}
                onCancel={() => setModal(false)}
                footer={
                    <div>
                        <Button type='default' onClick={() => setModal(false)}>
                            {t('DCC.close')}
                        </Button>
                    </div>
                }
            >
                <p>{t('DCC.modalContent')}</p>
                {isDCCModalLinkShown && (
                    <Link to={learnMoreDccUrl} target={'_blank'}>
                        {t('DCC.modalLink')}
                    </Link>
                )}
            </Modal>
        </>
    )
})

export default withTitle(DCC)
